import React from "react";
import PropTypes from "prop-types";
import SbEditable from "storyblok-react";
import useSettingsClassNames from "~hooks/use_settings_classnames/use_settings_classnames";
import { BLOK_ARRAY } from "../../../prop_types";
import * as classes from "./table.module.scss";

export default function Table({ table, settings, ...rest }) {
  const [settingsClassNames] = useSettingsClassNames(settings);

  const classNames = [classes.table, ...settingsClassNames];

  return (
    <SbEditable content={rest}>
      <table className={classNames.join(" ")}>
        {table.thead && table.thead.length > 0 && (
          <thead>
            <tr>
              {table.thead.map((item) => {
                return <th key={item._uid}>{item.value}</th>;
              })}
            </tr>
          </thead>
        )}
        {table.tbody && table.tbody.length > 0 && (
          <tbody>
            {table.tbody.map((rows) => {
              return (
                <tr key={rows._uid}>
                  {rows.body.map((columns, index) => {
                    if (index === 0) {
                      return (
                        <td className={classes.bold} key={columns._uid}>
                          {columns.value}
                        </td>
                      );
                    }
                    return <td key={columns._uid}>{columns.value}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        )}
      </table>
    </SbEditable>
  );
}

Table.defaultProps = {
  table: null,
  settings: null,
};

Table.propTypes = {
  table: PropTypes.shape(),
  settings: BLOK_ARRAY,
};
